export default {
  jobListings: [],
  jobListing: undefined,
};
